module.exports = __webpack_public_path__ + "static/media/collections_01.14c225e8.jpg";